// @ts-nocheck
import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import { BrowserRouter as Router } from "react-router-dom";
import KeyCloak from "./Auth/Keycloak";
import SessionTimeout from "./Auth/SessionTimeout";
import { ProvideAuth } from "./Auth/State/ProvideAuth";

const renderApp = () => ReactDOM.render(
    <Router>
        <SessionTimeout isAuthenticated={KeyCloak._kc} logOut={() => KeyCloak.doLogout()} />
        <ProvideAuth>
            <App />
        </ProvideAuth>
    </Router>
    ,
    document.getElementById('root')
);

KeyCloak.initKeycloak(renderApp);
